/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchGroupContractMembersCommand
 */
export interface SearchGroupContractMembersCommand {
    /**
     * Filters on the group contract identifier or on any of its members' identifiers.
     * @type {string}
     * @memberof SearchGroupContractMembersCommand
     */
    searchString?: string | null;
    /**
     * True to return only group contracts having at least one member without a mandate, i.e. whose direct debit cannot be issued.
     * @type {boolean}
     * @memberof SearchGroupContractMembersCommand
     */
    blockedOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SearchGroupContractMembersCommand
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchGroupContractMembersCommand
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SearchGroupContractMembersCommand interface.
 */
export function instanceOfSearchGroupContractMembersCommand(value: object): value is SearchGroupContractMembersCommand {
    return true;
}

export function SearchGroupContractMembersCommandFromJSON(json: any): SearchGroupContractMembersCommand {
    return SearchGroupContractMembersCommandFromJSONTyped(json, false);
}

export function SearchGroupContractMembersCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGroupContractMembersCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'blockedOnly': json['blockedOnly'] == null ? undefined : json['blockedOnly'],
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SearchGroupContractMembersCommandToJSON(json: any): SearchGroupContractMembersCommand {
    return SearchGroupContractMembersCommandToJSONTyped(json, false);
}

export function SearchGroupContractMembersCommandToJSONTyped(value?: SearchGroupContractMembersCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'blockedOnly': value['blockedOnly'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
    };
}

